export default {
  watch: {
    message: {
      handler(newValue) {
        // Si no hay mensaje o firma, no hacemos nada//
        if (!newValue || !this.signatureToApply) return;

        // Limpiamos espacios para evitar errores de comparación
        const currentContent = newValue.trim();
        const signatureContent = this.signatureToApply.trim();

        // Si el mensaje es exactamente la firma (o sea, acabamos de abrir el chat)
        if (currentContent === signatureContent) {
          this.forceCursorToEnd();
        }
      },
      flush: 'post',
    },
  },
  methods: {
    forceCursorToEnd() {
      // Intentamos mover el cursor en varios momentos para asegurarnos
      // (10ms, 100ms y 300ms) para vencer cualquier "lag" del navegador
      [10, 100, 300].forEach((delay) => {
        setTimeout(() => {
          this.executeMove();
        }, delay);
      });
    },

    executeMove() {
      // 1. Buscamos el componente usando la Referencia de Vue (Más preciso que querySelector)
      const messageInputComponent = this.$refs.messageInput;
      
      let textarea = null;

      // Si existe el componente (ResizableTextArea)
      if (messageInputComponent && messageInputComponent.$el) {
        // Buscamos el tag 'textarea' real dentro de él
        textarea = messageInputComponent.$el.querySelector('textarea') || messageInputComponent.$el;
      } 
      // Plan B: Si no encontramos la referencia, buscamos a la fuerza en todo el componente
      else if (this.$el) {
        textarea = this.$el.querySelector('textarea');
      }

      // 2. Si encontramos la caja de texto, movemos el cursor
      if (textarea && textarea.value) {
        // Solo enfocamos si no está enfocado ya (para evitar parpadeos molestos)
        // o si es el primer intento (delay corto)
        if (document.activeElement !== textarea) {
           textarea.focus();
        }

        // LA CLAVE: Ponemos el rango de selección al final absoluto
        const length = textarea.value.length;
        
        // Esta instrucción obliga al cursor a irse a la posición 'length' (el final)
        textarea.setSelectionRange(length, length);
        
        // Hacemos scroll abajo por si la firma es muy larga
        textarea.scrollTop = textarea.scrollHeight;
      }
    }
  },
};